/* eslint-disable @typescript-eslint/no-empty-function */
import { NavBarProps } from 'antd-mobile/es/components/nav-bar';
import React, { useState, useContext, createContext, ReactNode, useMemo, useCallback } from 'react';

interface navbarContextInterface extends NavBarProps {
  title: string;
  setTitle: (title: string) => void;
  setBackArrow: (b: boolean) => void;
  setBack: (b: string | null | undefined) => void;
  setOnBack: (onBack: () => void) => void;
  setRight: (r?: ReactNode | undefined) => void;
  onBack: () => void;
}

const navbarContext = createContext<navbarContextInterface | null>(null);

const ProvideNavbar = ({ children }: { children: ReactNode }): React.JSX.Element => {
  const navbar = useProvideNavbar();
  return <navbarContext.Provider value={navbar}>{children}</navbarContext.Provider>;
};
export default ProvideNavbar;

export const useNavbar = (): navbarContextInterface | null => {
  return useContext(navbarContext);
};

function useProvideNavbar(): navbarContextInterface {
  const [title, setTitle] = useState('Camionnet');
  const [back, setBack] = useState<string | null | undefined>();
  const [backArrow, setBackArrow] = useState(false);
  const [right, setRight] = useState<ReactNode | undefined>();
  const [onBack, setOnBack] = useState<() => void>(() => {});

  const setNavbarOnBack = useCallback(
    (newOnBack: () => void) => {
      setOnBack(() => newOnBack);
    },
    [setOnBack],
  );

  const setNavbarRight = useCallback(
    (newRight: ReactNode | undefined) => {
      setRight(newRight);
    },
    [setRight],
  );

  const contextValue = useMemo(
    () => ({
      title,
      setTitle,
      backArrow,
      setBackArrow,
      back,
      setBack,
      onBack,
      setOnBack: setNavbarOnBack,
      right,
      setRight: setNavbarRight,
    }),
    [title, backArrow, back, onBack, right, setNavbarOnBack, setNavbarRight, setTitle, setBackArrow, setBack],
  );

  return contextValue;
}
